import { useGetTeam } from "@/hooks/queryHooks/teamHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Link } from "react-router-dom";

export const TeamSummaryItem = ({
  tenantId,
  teamId,
}: {
  tenantId: string;
  teamId: string;
}) => {
  const { data: team } = useGetTeam(tenantId, teamId);
  const path = teamId ? new AppUrlPath(tenantId).getTeamPath(teamId) : "";

  return (
    <Link className="block hover:underline" to={path}>
      {!teamId || teamId === "org" ? "None" : team ? team.name : "Loading..."}
    </Link>
  );
};
